module.exports = __webpack_public_path__ + "static/media/hf1.png";